import React from 'react';
import classNames from 'classnames';

import css from './IconHairDryer.module.css';

/**
 * IconHairDryer icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconHairDryer = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
 <svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7085 6.72851C19.7085 4.23117 17.005 2.67034 14.8423 3.919C12.6795 5.16768 12.6795 8.28935 14.8423 9.53801C15.3354 9.82275 15.8949 9.97265 16.4643 9.97265C18.256 9.97265 19.7085 8.5202 19.7085 6.72851ZM16.4643 8.35057C15.2157 8.35057 14.4353 6.99886 15.0596 5.91747C15.6839 4.83609 17.2448 4.83609 17.8691 5.91747C18.0115 6.16406 18.0864 6.44378 18.0864 6.72851C18.0864 7.62435 17.3602 8.35057 16.4643 8.35057ZM17.4193 18.7541L20.6209 11.7032C24.4504 8.4967 23.3727 2.34707 18.6811 0.633853C17.9707 0.374475 17.2205 0.241256 16.4643 0.240234C16.4195 0.240422 16.3748 0.244153 16.3305 0.251381L2.41013 2.57196C1.62806 2.70229 1.05481 3.37887 1.05469 4.17172V9.2853C1.05481 10.0782 1.62806 10.7547 2.41013 10.8851L12.4092 12.5517V18.083C12.4092 18.9788 13.1354 19.705 14.0312 19.7051C14.0312 21.9446 15.8469 23.7601 18.0864 23.7602H19.7085C20.3328 23.7602 20.723 23.0844 20.4109 22.5437C20.266 22.2928 19.9982 22.1382 19.7085 22.1382H18.0864C16.7427 22.1382 15.6533 21.0488 15.6533 19.7051H15.9422C16.5785 19.7052 17.1561 19.3334 17.4193 18.7541ZM2.67676 4.17172L16.5292 1.86231C20.2752 1.86396 22.6147 5.92015 20.7403 9.16347C19.8711 10.6674 18.2662 11.594 16.5292 11.5947L2.67676 9.28631V4.17172ZM16.3305 13.2056C16.3748 13.2129 16.4195 13.2166 16.4643 13.2168C17.0757 13.2166 17.6839 13.1299 18.2709 12.9593L15.9392 18.083H14.0312V12.8224L16.3305 13.2056Z" fill="#262338"/>
</svg>

  );
};

export default IconHairDryer;
